export default __webpack_public_path__ + "static/media/photo--sm--games.b2046ab8.jpg";